export const HeroData = [
  {
    src: "hero/person1.jpg",
    bg: "#0be4d1",
    delay: 0.1,
    
  },
  {
    src: "hero/person2.jpg",
    bg: "#fde490",
    delay: 0.3,
  },
  {
    src: "hero/h-b1.jpg",
    bg: "#00c9f7",
    delay: 0.2,
    des:"Your",
  },
  {
    src: "hero/h-b22.jpg",
    bg: "#83cfdf",
    delay: 0.2,
    des:"Sustainable",
  },
  {
    src: "hero/h-b3.jpg",
    bg: "#fe8856",
    delay: 0.3,
    des:"End to End",
  },
  {
    src: "hero/h-b2.jpg",
    bg: "#0be4d1",
    delay: 0.25,
    des:"Solution",
  },
];
export const features = [
  {
    icon: "/features/Frame-0.png",
    title: "3x monthly revenue",
  },
  {
    icon: "/features/Frame-1.png",
    title: "Flat fee of 6-12%",
  },
  {
    icon: "/features/Frame-2.png",
    title: "Flexible repayments",
  },
  {
    icon: "/features/Frame-3.png",
    title: "3-4 years repayment",
  },
  {
    icon: "/features/Frame-4.png",
    title: "$10-100k seed investment",
  },
  {
    icon: "/features/Frame-5.png",
    title: "revenue up to 3X cap",
  },
];

export const ourDiffFeatures = [
  {
    icon: "/OurDiff/Frame-0.png",
    title: "Best Automation Robots",
    des: "Our mission is to level the playing field for early stage growth capital. We provide capital that ",
  },
  {
    icon: "/OurDiff/Frame-1.png",
    title: "Ease In process",
    des: "Funding that flexes as revenue grows with transparent costs and does not require dilution, personal ",
  },
  {
    icon: "/OurDiff/Frame-2.png",
    title: "Mutliple Ports Availability",
    des: "On demand expertise to supercharge growth in areas that are hard to access for early stage founders",
  },
];

export const hitFeatures = [
  {
    icon: "/howItWorks/Frame-0.png",
    title: "Autonomous Solution",
    des: "GPS-guided cleaning for ships on the go. Our autonomous robots use GPS navigation to clean ship hulls automatically, without the need for human intervention.",
  },
  {
    icon: "/howItWorks/Frame-1.png",
    title: "Semi-autonomous Solution",
    des: "Remotely controlled cleaning for hard-to-reach areas. Our semi-autonomous robots are remotely operated by skilled technicians, allowing them to clean hard-to-reach areas and complex hull geometries.",
  },
  {
    icon: "/howItWorks/Frame-2.png",
    title: "Dry-docking",
    des: "Lifted and cleaned for a pristine hull. Our dry cleaning service uses a state-of-the-art lift system to raise ships out of the water so that their hulls can be cleaned and inspected.",
  },
];

export const whoWeInvest = [
  {
    title: "Digital Business Model",
    des: "Digital business model e.g. SaaS, subscription, D2C, apps",
  },
  {
    title: "Revenue Generating",
    des: "Revenue generating for 6 months, > $1k in monthly recurring revenue",
  },
  {
    title: "Support Growth",
    des: "Industry expertise: Fintech, Health, Deep tech, B2B software",
  },
  {
    title: "International Expansion",
    des: "Registered in Australia and Singapore (initially) with appetite for international expansion",
  },
];

export const testimonialsData = [
  {
    comment:
      "SUPER HAPPY! Not only do you get to see the best seed and Early Stage companies but the exciting part is there’s a bunch of investors",
    name: "Zach Lee",
    profession: "QA specialist, Matrix architect",
  },
  {
    comment:
      "I have been working with ZAINKEEPSCODE on our fundraising strategies. They understands the in depth strategies of Venture Capital and early stage fund raising/company",
    name: "Cheryl R. Weiss",
    profession: "Founder, Dubrow Cafeteria",
  },
  {
    comment:
      "Another masterpiece really digging into the art of venture funds, portfolio construction and deal mechanics! Loved it - I can say without hesitation that it is incredibly valuable for anyone who is investing",
    name: "Vicky R. Lane",
    profession: "Directork, Lafayette Radio",
  },
  {
    comment:
      "BlueVenture is the premier setting for entrepreneurs and investors alike to exchange ideas, and network. As an entrepreneur, I can rely on the BlueVenture to bring top caliber speakers, entrepreneurs and investors",
    name: "Jennifer Dubois",
    profession: "Manager, China Coast",
  },
];



export const serviceDropdown = [
  {
    id: 1,
    title: "Marketing",
    path: "./h-wrapper",
    cName: "submenu-item",
  },
  {
    id: 2,
    title: "Consulting",
    path: "./h-wrapper",
    cName: "submenu-item",
  },
  {
    id: 3,
    title: "Design",
    path: "./h-wrapper",
    cName: "submenu-item",
  },
  {
    id: 4,
    title: "Development",
    path: "./h-wrapper",
    cName: "submenu-item",
  },
];
